module.exports = __webpack_public_path__ + "img/5.a912e962.png";